import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { filter, finalize, take } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  hide = true;
  hasError = false;
  errorMessage = '';
  showForgetPasswordPage = false;
  formLogin: FormGroup | any;
  loading = false;
  isNavigating = false;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.formLogin = this.fb.group({
      mail: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

 

  onAutofill(event: AnimationEvent, controlName: string, input: HTMLInputElement) {
    if (event.animationName === 'onAutoFillStart') {
      this.formLogin.get(controlName)?.setValue(input.value);
    }
  }

  login() {
    this.loading = true;
    const mail = this.formLogin.get('mail').value;
    const password = this.formLogin.get('password').value;

    this.authService
      .login(mail, password)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.authService.userSubject
            .pipe(
              filter((user) => user !== null && user !== undefined),
              take(1)
            )
            .subscribe((user) => {
              this.isNavigating = true;
              window.setTimeout(() => this.router.navigate(['/dashboard']), 360);
            });
        },
        error: (errorMessage) => {
          this.hasError = true;
          this.errorMessage = errorMessage
            ? errorMessage
            : 'O e-mail informado não está cadastrado ou a senha está incorreta. Verifique os dados digitados e tente entrar novamente.';
        },
      });
  }
}
